import { EngagementsUsageState, EngagementUsageState } from '../state/engagementsUsageState';
import { AppAction } from '../actions/appAction';
import produce from 'immer';

const unloaded: EngagementsUsageState = { byId: new Map() };

export function engagementsUsageReducer(state: EngagementsUsageState | undefined = unloaded, action: AppAction): EngagementsUsageState {
    switch (action.type) {
		case 'engagements-usage/initialized':
			return produce(state, draft => {
				let engagementState: EngagementUsageState | undefined = draft.byId.get(action.engagementId);
				
				if (engagementState) {
					engagementState.initialized = true;
				} else {
					engagementState = {
						initialized: true,
						usage: null
					};
				}
				
				draft.byId.set(action.engagementId, engagementState);
			});
		case 'engagements-usage/updated':
			return produce(state, draft => {
				const engagementState = draft.byId.get(action.engagementId);
				if (!engagementState)
					return;
				
				engagementState.usage = action.usage;
			});
		default:
			return state;
	}
}
